import clsx from "clsx";
import { Icon } from "../icons";
import type { ChildrenProps } from "../types";

/** Props Interface */
interface RemoveWrapperProps extends ChildrenProps {
	hasValue: boolean;
	handleOnRemove: () => void;
	isNullable: boolean;
}

export function RemoveWrapper({
	children,
	handleOnRemove,
	isNullable,
	hasValue,
}: RemoveWrapperProps) {
	/** Guard */
	if (!isNullable) return children;
	if (!hasValue) return children;

	/** Render */
	return (
		<div className="flex flex-row gap-0">
			{children}
			<div
				onClick={handleOnRemove}
				className={clsx(
					"flex-center bg-blue-500 pr-3 pl-4 -translate-x-1.5",
					"bg-primary-100 dark:bg-primary-950",
					"cursor-pointer",
					"border-[0.5px] border-color",
					"rounded-r-base",
				)}
			>
				<Icon
					name="X"
					size={10}
					className="stroke-red-500 dark:stroke-red-400"
				/>
			</div>
		</div>
	);
}
